import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type HybridKekObj } from '../../services/hybrid/hybridKekService'

export interface HybridKekListState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  hybridKekList: HybridKekObj | null
}

const initialState: HybridKekListState = {
  isLoading: false,
  error: null,
  httpStatus: 0,
  hybridKekList: null
}

const hybridKekListSlice = createSlice({
  name: 'hybridKekList',
  initialState,
  reducers: {
    hybridKekListLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        hybridKekList: null
      }
    },
    hybridKekListUpdateAction: (state, action: PayloadAction<{ data: HybridKekObj, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        hybridKekList: action.payload.data
      }
    },
    hybridKekListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        hybridKekList: null
      }
    }
  }
})

export const {
  hybridKekListLoadingAction,
  hybridKekListUpdateAction,
  hybridKekListErrorAction
} = hybridKekListSlice.actions

export default hybridKekListSlice.reducer
